





































import Proxyable from '@/mixins/proxyable';
import {
  FormField,
  FormFieldType,
  FormFieldTypeEnum,
  FormSectionField,
  IFormFieldType,
  IFormSection
} from '@/models';
import { ErrorManager } from '@/models/error';
import { PropType } from 'vue';
import { mapActions } from 'vuex';

import ErrorAlert from '@/components/common/ErrorAlert.vue';

export default Proxyable.extend({
  name: 'FormBuilderSectionFieldsDrawer',

  components: { ErrorAlert },

  props: {
    value: Object as PropType<IFormSection>,
    fieldDrawer: Boolean,
    templateId: Number
  },

  data() {
    return {
      loading: false,

      errorMessage: '',
      detailErrorMessage: ''
    };
  },

  computed: {
    drawer: {
      get(): boolean {
        return this.fieldDrawer;
      },
      set(value: boolean) {
        this.$emit('update:fieldDrawer', value);
      }
    },

    fieldTypes(): IFormFieldType[] {
      return FormFieldType.getFormFieldTypeList();
    }
  },

  methods: {
    ...mapActions({
      createFormField: 'formTemplate/createFormField'
    }),

    addField(fieldTemplateId: number) {
      const field = new FormSectionField({
        order: this.internalValue.section_fields.length!,
        width: 12,
        field_template: fieldTemplateId,
        required: false,
        disabled: false,
        create_todo: false,
        constraints: []
      });

      this.internalValue.section_fields.push(field);

      this.save();
    },

    createNewField(type: IFormFieldType) {
      this.clearAllErrors();
      this.loading = true;

      const payload = new FormField({
        label: `${type.text} field`,
        hint: '',
        type: type.value,
        meta_label: ''
      });

      this.createFormField(payload)
        .then(data => {
          this.addField(data.id);
        })
        .catch(error => {
          if (error.response) {
            if (error.response.data.detail) {
              this.errorMessage = error.response.data.detail;
            }
          }
          this.errorMessage = ErrorManager.extractApiError(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    save() {
      this.$emit('save');
      this.close();
    },

    close() {
      this.drawer = false;
    },

    clearAllErrors() {
      this.errorMessage = '';
      this.detailErrorMessage = '';
    }
  }
});
